'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = configureStore;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _chemist = require('chemist');

var _logger = require('./middleware/logger');

var _logger2 = _interopRequireDefault(_logger);

var _flash = require('./middleware/flash');

var _flash2 = _interopRequireDefault(_flash);

var _gtm = require('./middleware/gtm');

var _gtm2 = _interopRequireDefault(_gtm);

var _launch = require('./middleware/launch');

var _launch2 = _interopRequireDefault(_launch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(history, client, data) {
  var middleware = [(0, _chemist.requestMiddleware)({ api: client }), (0, _reactRouterRedux.routerMiddleware)(history), (0, _flash2.default)(), (0, _gtm2.default)(), (0, _launch2.default)()];

  if (__DEVELOPMENT__) {
    middleware.push((0, _logger2.default)());
  }

  var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);

  var reducer = require('../reducers');

  var devToolsDefined = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && typeof window.devToolsExtension !== 'undefined';

  function loadDevTools() {
    if (devToolsDefined) {
      return window.devToolsExtension();
    }

    return function (f) {
      return f;
    };
  }

  if (__DEVELOPMENT__) {
    var store = createStoreWithMiddleware(reducer, (data, loadDevTools()));
    if (__DEVELOPMENT__ && module.hot) {
      module.hot.accept('../reducers', function () {
        store.replaceReducer(require('../reducers'));
      });
    }
    return store;
  }

  return createStoreWithMiddleware(reducer, function (f) {
    return f;
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/store/index.js
// module id = 2360
// module chunks = 0